import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TimetableService {
  public x;


  constructor(private http: HttpClient) { }
  getDays(){
    return this.http.get<any>("/edozzier/portal-timetable-days.php");
  }

  getPeriods(){
    return this.http.get<any>("/edozzier/portal-timetable-periods.php");
  }

  getVenues(){
    return this.http.get<any>("/edozzier/portal-timetable-venues.php");
  }

  getTimeTable(){
    return this.http.get<any>("/edozzier/portal-timetable.php");
  }
}
